var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Sound component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconSound extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.8798 3.69337C13.5126 3.51796 13.1055 3.44268 12.6999 3.47513C12.2942 3.50759 11.9043 3.64661 11.5696 3.87817L5.51736 8.12988H3.41564C2.80295 8.12988 2.21534 8.37328 1.7821 8.80652C1.34886 9.23976 1.10547 9.82736 1.10547 10.4401V13.5604C1.10547 14.1731 1.34886 14.7607 1.7821 15.1939C2.21534 15.6272 2.80295 15.8706 3.41564 15.8706H5.51531L11.4182 20.113L11.4292 20.1206C11.7639 20.3521 12.1538 20.4912 12.5595 20.5236C12.9622 20.5559 13.3663 20.4819 13.7315 20.3092C14.1263 20.13 14.4627 19.8434 14.7023 19.4819C14.9436 19.118 15.0768 18.6932 15.0864 18.2567L15.0866 18.2401V5.76674C15.0947 5.35523 14.9927 4.94897 14.791 4.59002C14.5877 4.22823 14.2908 3.92786 13.9313 3.72049C13.9145 3.71079 13.8973 3.70174 13.8798 3.69337ZM6.5059 14.7353L12.2873 18.8902C12.4036 18.9695 12.5387 19.0172 12.6791 19.0284C12.8213 19.0398 12.9641 19.0134 13.0929 18.9519L13.1088 18.9445C13.2485 18.8817 13.3675 18.7807 13.4521 18.6531C13.5354 18.5274 13.582 18.381 13.5866 18.2304V5.75869L13.5868 5.74083C13.5903 5.59534 13.5545 5.4516 13.4832 5.32472C13.4167 5.20632 13.3216 5.10668 13.2068 5.0348C13.085 4.98195 12.9521 4.95975 12.8195 4.97035C12.678 4.98168 12.5419 5.02999 12.425 5.11043L6.5059 9.26857V14.7353ZM2.84276 9.86718C2.9947 9.71524 3.20077 9.62988 3.41564 9.62988H5.0059V14.3706H3.41564C3.20077 14.3706 2.9947 14.2852 2.84276 14.1333C2.69083 13.9813 2.60547 13.7753 2.60547 13.5604V10.4401C2.60547 10.2252 2.69083 10.0191 2.84276 9.86718ZM20.0997 6.74046C20.4189 6.47645 20.8917 6.52118 21.1557 6.84035C22.3566 8.29229 22.974 10.1392 22.8877 12.0212C22.8604 14.0773 22.2844 16.0889 21.2193 17.848C21.0048 18.2023 20.5436 18.3156 20.1893 18.1011C19.835 17.8865 19.7216 17.4254 19.9362 17.0711C20.8649 15.5372 21.3662 13.7827 21.388 11.9898C21.388 11.9862 21.3881 11.9826 21.3882 11.979C21.3883 11.9737 21.3885 11.9685 21.3888 11.9632C21.4608 10.4498 20.9655 8.96392 19.9998 7.79641C19.7358 7.47723 19.7805 7.00447 20.0997 6.74046ZM18.035 9.1802C17.771 8.86102 17.2982 8.8163 16.979 9.08031C16.6598 9.34431 16.6151 9.81708 16.8791 10.1363C17.3025 10.648 17.5196 11.2994 17.488 11.9628C17.4869 11.9866 17.4869 12.0104 17.488 12.0342C17.5196 12.6976 17.3025 13.3489 16.8791 13.8607C16.6151 14.1799 16.6598 14.6527 16.979 14.9167C17.2982 15.1807 17.771 15.1359 18.035 14.8168C18.6888 14.0263 19.0278 13.0227 18.9878 11.9985C19.0278 10.9742 18.6888 9.97068 18.035 9.1802Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconSound.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconSound.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconSound.prototype, "size", void 0);
if (customElements.get('cat-icon-sound') === undefined) {
    customElements.define('cat-icon-sound', BlocksIconSound);
}
